module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topBox"
  }, [_c('div', {
    staticClass: "top_box_text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "top_box_data"
  }, [_vm._v(_vm._s(_vm.parseDataType(_vm.topData)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-270ea70c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/TopBox.vue
// module id = 835
// module chunks = 1